import {
  ColDef,
  FirstDataRenderedEvent,
  GetDetailRowDataParams,
  GridOptions,
  ICellRendererParams,
} from "ag-grid-community";
import { PfSubRequest } from "../../generated-models/PfSubRequest";

export interface PfSubRequestParentRow {
  subRequests: PfSubRequest[];
}

export function getPfSubRequestColumnDefs(): ColDef[] {
  return [
    {
      headerName: "Zone",
      field: "Zone",
    },
    {
      headerName: "Cluster",
      field: "Cluster",
    },
    {
      headerName: "SKU",
      field: "SKU",
    },
    {
      headerName: "Quantity",
      field: "Quantity",
    },
  ];
}

export function getPfSubRequestDefaultColDef(): ColDef {
  return {
    resizable: true,
    sortable: false,
    suppressMenu: true,
  };
}

export function configurePfSubRequestExpansion(gridOptions: GridOptions): void {
  gridOptions.masterDetail = true;
  gridOptions.detailRowAutoHeight = true;
  gridOptions.isRowMaster = (data: PfSubRequestParentRow) => data.subRequests.length > 0;
  gridOptions.detailCellRendererParams = {
    template: (params: ICellRendererParams<PfSubRequestParentRow>) => {
      const requestIdColumnOffset = params.api.getColumn("requestId")?.getLeft() ?? 0;
      return `
        <div class="ag-details-row pf-subrequest-detail-row" role="gridcell">
          <div
            ref="eDetailGrid"
            class="ag-details-grid pf-subrequest-detail-grid"
            style="--pf-subrequest-detail-offset: ${requestIdColumnOffset}px"
            role="presentation"
          ></div>
        </div>
      `;
    },
    detailGridOptions: {
      defaultColDef: getPfSubRequestDefaultColDef(),
      columnDefs: getPfSubRequestColumnDefs(),
      domLayout: "autoHeight",
      onFirstDataRendered: (params: FirstDataRenderedEvent<PfSubRequest>) => params.api.sizeColumnsToFit(),
    },
    getDetailRowData: (params: GetDetailRowDataParams<PfSubRequestParentRow, PfSubRequest>) =>
      params.successCallback(params.data.subRequests),
  };
}